<template>
 <v-app>
  <v-content>
   <section class="content">
    <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs" id="custom-content-above-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="pill" href="javascript:void(0)" aria-selected="true">  Permintaan</a>
              </li>
              <li class="nav-item">
                <router-link to="/uang_keluar_permintaan_cek_selesai" class="nav-link">
                   Selesai</a>
                </router-link>
              </li>
              
            </ul>
          </div>
        </div>
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Daftar Permintaan Cek</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body ">
                <div class="row">
                  <!--div class="col-md-3 text-left">
                    <button type="button" class="btn btn-sm btn-success" >
                      <i class="fa fa-download"></i>
                      Download Rekap
                    </button>
                  </div-->
                  <!--div class="col-md-3 text-center">
                    <i class="fas fa-question-circle " aria-hidden="true" title="BELUM DIJAWAB"></i> <span>Belum Dijawab</span>
                    <br>
                    {{jumlahbelum | toCurrency}}
                  </div>
                  <div class="col-md-3 text-center">
                    <i class="fas fa-times-circle text-red" aria-hidden="true" title="DITOLAK"></i> <span>Ditolak</span>
                    <br>
                    {{jumlahtolak | toCurrency}}
                  </div>
                  <div class="col-md-3 text-center">
                    <i class="fas fa-check-circle text-green" aria-hidden="true" title="DITERIMA"></i> <span>Disetujui</span>
                    <br>
                    {{jumlahaccept | toCurrency}}
                  </div-->
                  
                </div>
                <!--div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      
                        <label>Bulan Permintaan</label>
                        <v-dialog
                          ref="dialog"
                          v-model="modaltgl"
                          :return-value.sync="tanggal_query"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field style="margin-top:0px;padding-top:0px"
                              v-model="tanggal_query"
                            
                              label=""
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="tanggal_query"
                            type="month"
                            scrollable
                            min="2022-08"
                            :max="dateMax"
                            
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modaltgl = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="ubahTanggalTampil($refs)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                    </div>
                  </div>
                </div-->
                
                <div class="row">
                  <div class="col-md-12 table-responsive p-0">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>Nomor Cek</th>
                          <th>Kategori</th>
                          <!--th>Total</th-->
                          <th>Tanggal Dibuat</th>
                          <th>Oleh</th>
                          <!--th>Status</th-->
                          <th>Detail Barang</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!--//pakein data parent tablecola sama tdsembunyi-->
                        <template v-if="(datas)" v-for="(row, index) in datas" >

                          <tr  v-if="(index > 0 && datas[index-1].tiket != row.tiket) || (index == 0)"  :key="'row'+row.kategori_id+'_'+row.tiket">
                            
                            <td data-toggle="collapse" :data-target="'#accordion'+row.kategori_id+'_'+row.tiket" class="accordion-toggle">{{row.tiket}}</td>
                            <td data-toggle="collapse" :data-target="'#accordion'+row.kategori_id+'_'+row.tiket" class="accordion-toggle">{{row.kategori_keuangan_cek.value}}</td>
                            <!--td>{{row.jumlah | toCurrency}}</td-->
                            <td data-toggle="collapse" :data-target="'#accordion'+row.kategori_id+'_'+row.tiket" class="accordion-toggle">{{row.created_at | indoDate}}</td>
                            <td data-toggle="collapse" :data-target="'#accordion'+row.tiket" class="accordion-toggle">{{row.user_cek.name}}</td>
                            <!--td>
                              <span v-if="row.statusnya.includes(2)"><i class="fas fa-times-circle text-red" aria-hidden="true" title="DITOLAK"></i></span>
                              <span v-else-if="row.statusnya.every((val, i, arr) => val === arr[0] && val == 1)"><i class="fas fa-check-circle text-green" aria-hidden="true" title="DITERIMA"></i></span>
                              <span v-else><i class="fas fa-question-circle " aria-hidden="true" title="BELUM DIJAWAB"></i></span>
                            </td-->
                            <td>
                              
                              <!--a  title="Upload Bukti" href="#" @click="uploadModal(row)" class="ml-1" v-if="row.statusnya.every((val, i, arr) => val === arr[0] && val == 1) && row.is_selesai != 1">
                                <i class="fas fa-upload text-warning" aria-hidden="true"></i>
                              </a-->
                              <a  title="Edit Permintaan" href="#" @click="editPermintaan(row.id)" class="ml-1" v-if="row.statusnya.includes(2) || row.statusnya.every((val, i, arr) => val === arr[0] && val == 0)">
                                <i class="fas fa-edit text-warning" aria-hidden="true"></i>
                              </a>
                              <a  title="Hapus Permintaan" href="#" @click="deletePermintaan(row.id)" class="ml-1" v-if="row.statusnya.includes(2) || row.statusnya.every((val, i, arr) => val === arr[0] && val == 0)">
                                <i class="fas fa-trash text-danger" aria-hidden="true"></i>
                              </a>
                            </td>
                            <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                            <!--td>

                              <a href="#" v-if="row.status == 'ditolak' || row.status == 'pending'" @click="deleteData(row.id)">
                                  <i class="fa fa-trash red"></i>
                              </a>
                            </td-->
                          </tr>
                          <tr v-if="(index > 0 && datas[index-1].tiket != row.tiket) || (index == 0)">
                            <td colspan="5" class="tdSembunyi">
                              <div class="collapse pl-4 pr-4 pb-2 pt-2" :id="'accordion'+row.kategori_id+'_'+row.tiket"> 
                                <div class="row ">
                                  <div class="col-md-1">
                                    
                                  </div>
                                  <div class="col-md-4">
                                    <s v-if="row.is_selesai">
                                      <strong>Barang</strong> : {{row.nama_barang }}
                                    </s>
                                    <span v-else>
                                      <strong>Barang</strong> : {{row.nama_barang }}
                                    </span>
                                  </div>
                                  <div class="col-md-4">
                                    <s v-if="row.is_selesai">
                                      <strong>Harga</strong> : {{row.harga_barang | toCurrency}}
                                    </s>
                                    <span v-else>
                                      <strong>Harga</strong> : {{row.harga_barang | toCurrency}}
                                    </span>
                                  </div>
                                  <div class="col-md-2">
                                    
                                    <a v-if="row.is_selesai" href="#" @click="bukaDetailApprovalModal(row.pejabat_approval_cek)" class="mr-2" title="Lihat Detail Approval">
                                        <i class="fas fa-check-circle text-success" aria-hidden="true"></i>
                                    </a>
                                    <a v-if="!row.is_selesai" href="#" @click="bukaDetailApprovalModal(row.pejabat_approval_cek)" class="mr-2" title="Lihat Detail Approval">
                                        <i class="fas fa-table" aria-hidden="true"></i>
                                    </a>

                                    <a  title="Hapus Barang" href="#" @click="deleteBarang(row.id)" class="ml-1" v-if="(row.statusnya.includes(2) || row.statusnya.every((val, i, arr) => val === arr[0] && val == 0)) && !row.is_selesai">
                                      <i class="fas fa-trash text-danger" aria-hidden="true"></i>
                                    </a> 
                                  </div>
                                  <div class="col-md-1">
                                    
                                  </div>
                                </div>
                                
                              </div> 
                            </td>
                            
                          </tr>
                          <tr v-if="(index > 0 && datas[index-1].tiket == row.tiket)">
                            <td colspan="5" class="tdSembunyi">
                              <div class="collapse pl-4 pr-4 pb-2 pt-2" :id="'accordion'+row.kategori_id+'_'+row.tiket"> 
                                <div class="row ">
                                  <div class="col-md-1">
                                    
                                  </div>
                                  <div class="col-md-4">
                                    <s v-if="row.is_selesai">
                                      <strong>Barang</strong> : {{row.nama_barang }}
                                    </s>
                                    <span v-else>
                                      <strong>Barang</strong> : {{row.nama_barang }}
                                    </span>
                                  </div>
                                  <div class="col-md-4">
                                    <s v-if="row.is_selesai">
                                      <strong>Harga</strong> : {{row.harga_barang | toCurrency}}
                                    </s>
                                    <span v-else>
                                      <strong>Harga</strong> : {{row.harga_barang | toCurrency}}
                                    </span>
                                  </div>
                                  <div class="col-md-2">
                                    
                                    <a v-if="row.is_selesai" href="#" @click="bukaDetailApprovalModal(row.pejabat_approval_cek)" class="mr-2" title="Lihat Detail Approval">
                                        <i class="fas fa-check-circle text-success" aria-hidden="true"></i>
                                    </a>
                                    <a v-if="!row.is_selesai" href="#" @click="bukaDetailApprovalModal(row.pejabat_approval_cek)" class="mr-2" title="Lihat Detail Approval">
                                        <i class="fas fa-table" aria-hidden="true"></i>
                                    </a>
                                    
                                    <a  title="Hapus Barang" href="#" @click="deleteBarang(row.id)" class="ml-1" v-if="(row.statusnya.includes(2) || row.statusnya.every((val, i, arr) => val === arr[0] && val == 0)) && !row.is_selesai" >
                                      <i class="fas fa-trash text-danger" aria-hidden="true"></i>
                                    </a> 
                                  </div>
                                  <div class="col-md-1">
                                    
                                  </div>
                                </div>
                                
                              </div> 
                            </td>
                          </tr>
                          <!--tr>
                              <td colspan="6">
                                  <div id="accordion" class="collapse">Hidden by default</div>
                              </td>
                          </tr-->
                        </template>
                        <tr v-if="(!datas)" >

                          <td colspan="8" class="text-center"><h3>Data Kosong</h3></td>
                          <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                          <!--td>

                            <a href="#" v-if="row.status == 'ditolak' || row.status == 'pending'" @click="deleteData(row.id)">
                                <i class="fa fa-trash red"></i>
                            </a>
                          </td-->
                        </tr>
                      </tbody>
                      <!--tfoot>
                        <tr>
                          <th colspan="3">Total</th>
                          <th colspan="5">{{this.jumlahnya | toCurrency}}</th>
                          
                        </tr>
                      </tfoot-->
                    </table>
                  </div>
                </div>
                
              </div>
              <!-- /.card-body -->
              <!--div class="card-footer">
                  <pagination :data="datas" @pagination-change-page="getResults"></pagination>
              </div-->
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Tambah Pengeluaran</h5>
                    <!--h5 class="modal-title" v-show="editmode">Edit Pengeluaran</h5-->
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="createData()" enctype="multipart/form-data">
                    <div class="modal-body">
                       
                            <!--div class="form-group">
                                <v-menu
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="form.tanggal"
                                      label="Tanggal Pengeluaran"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-pickersaldo
                                    v-model="form.tanggal"
                                    @input="menu = false"
                                  ></v-date-picker>
                                </v-menu>
                                <small  v-if="adaeror['tanggal']" class="text-danger">
                                  {{adaeror["tanggal"].join(', ') }}
                                </small> 
                                <has-error :form="form" field="tanggal"></has-error>
                            </div-->
                          
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <label>Kas Kantor</label>
                              <select name="kantor_id" v-model="form.kantor_id" id="kantor_id" class="form-control" :class="{ 'is-invalid': adaeror['kantor_id'] }" required @change="changeKantor()">
                                  <option value="" selected disabled>-- PILIH KANTOR --</option>
                                  <option 
                                    v-for="row in kantor_list" :key="row.id"
                                    :value="{ id: row.id, text: row.value, saldo:row.saldo_akhir.saldo, maksimal: parseInt(row.saldo_akhir.saldo - (parseInt(row.saldo_akhir.saldo*10/100))) }"
                                    :selected="row.id == form.kantor_id.id">{{ row.value }}</option>
                              </select>
                              <small  v-if="adaeror['kantor_id']" class="text-danger">
                                {{adaeror["kantor_id"].join(', ') }}
                              </small>
                            </div>
                            <div class="col-md-6">
                              <label>Saldo</label>
                              <h5>{{this.form.kantor_id.saldo | toCurrency}}</h5> 
                                  <small>Rp Saldo Kantor Saat ini</small> 
                              <small  v-if="adaeror['maksimal']" class="text-danger">
                                {{adaeror["maksimal"].join(', ') }}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <label >Kode Cek</label>
                              <input type="text" v-model="form.tiket"  name="tiket"
                                  class="form-control" :class="{ 'is-invalid': adaeror['tiket']  }" required  :disabled="kantorBelumTerpilih">
                              <small  v-if="adaeror['jumlah']" class="text-danger">
                                                {{adaeror["jumlah"].join(', ') }}
                                              </small> 
                            </div>
                            <div class="col-md-6">
                              <label>Kategori Pengeluaran</label>
                              <select name="kategori" v-model="form.kategori" id="kategori" class="form-control " :class="{ 'is-invalid': adaeror['kategori']}" required @change="countBudgetnya()" :disabled="kantorBelumTerpilih">
                                  <option value="" disabled selected>-- PILIH KATEGORI PENGELUARAN --</option>
                                  <option  
                                    v-for="row in kategori_list" :key="row.id"
                                    :value="{ id: row.id, text: row.kategori_nama, sisa:  parseInt(row.budget-row.realisasi), budget: row.budget}"
                                    :selected="row.id == form.kategori.id">{{ row.kategori_nama }}</option>
                              </select>
                              <small  v-if="adaeror['kategori']" class="text-danger">
                                {{adaeror["kategori"].join(', ') }}
                              </small> 
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-md-10"><h5 >List Barang</h5> 
                              </div>
                          <div class="col-md-2 text-right mt-auto mb-2">
                            <a href="#" @click="addBarang()" class="" title="Tambah Barang">
                              <i class="fas fa-plus" aria-hidden="true"></i>
                            </a> 
                          </div>
                        </div>

                        <!--div class="form-group">
                          <div class="row">
                            
                            <div class="col-md-5">
                              <label >Nama Barang</label>
                              <input type="text" 
                                  class="form-control"  required :disabled="kategoriBelumTerpilih"> 
                            </div>
                            <div class="col-md-5">
                              <label >Harga</label>
                              <input type="number" @keydown="preventArrow($event)" 
                                  class="form-control" :min="0" required :disabled="kategoriBelumTerpilih">
                            </div>
                            <div class="col-md-2 text-right mt-auto mb-2">
                              <a href="#" @click="addBarang()" class="" title="Tambah Barang">
                                <i class="fas fa-plus" aria-hidden="true"></i>
                              </a> 
                            </div>
                          </div>
                        </div-->
                        <div id="row_barang">
                          <div class="form-group" v-for="(item,key) in form.barang" :key="item.key">
                            <div class="row">
                              
                              <div class="col-md-5">
                                <input type="text" v-model="form.barang[key].barang"
                                    class="form-control" required placeholder="Nama Barang">
   
                              </div>
                              <div class="col-md-5">
                                <input type="number" @keydown="preventArrow($event)"  v-model="form.barang[key].harga" 
                                    class="form-control"  :min="0" required placeholder="Harga Barang">
                              </div>
                              <!-- <div class="col-md-1 text-right mt-auto mb-2">
                                <a href="#" @click="addBarang()" class="" title="Tambah Barang">
                                  <i class="fas fa-plus" aria-hidden="true"></i>
                                </a>  
                              </div> -->
                              <div class="col-md-1 text-right mt-auto mb-2">
                                <a href="#" @click="removeBarang(key)" class="" title="Hapus Barang">
                                  <i class="fas fa-minus text-red" aria-hidden="true"></i>
                                </a> 
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="form-group">
                          <label>Pejabat Approval</label>
                          <div class="form-check"  v-for="row in pejabat_list">
                              <input type="checkbox" v-model="form.pejabat_approval" :id="'ch'+row.id" :value="row.id" :name="'ch'+row.id" class="form-check-input"> 
                              <label :for="'ch'+row.id" class="form-check-label">
                                  {{row.name}}
                              </label>
                          </div>
                          <div v-if="!pejabat_list.length">
                              <span class="text-red">Gagal Mengambil Pejabat Approval</span>
                          </div>
                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <!--button v-show="editmode" type="submit" class="btn btn-success">Edit!</button-->
                        <button type="submit" class="btn btn-primary">Tambah!</button>
                    </div>
                    
                  </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="KeteranganModal" tabindex="-1" role="dialog" aria-labelledby="KeteranganModal" aria-hidden="true" data-backdrop="static" data-keyboard="false" >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Keterangan Pengeluaran </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeKeteranganModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                      
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          {{tampilKet}}
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeKeteranganModal()">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="DetailApprovalModal" tabindex="-1" role="dialog" aria-labelledby="DetailApprovalModal" aria-hidden="true" data-backdrop="static" data-keyboard="false" >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Detail Approval </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeDetailApprovalModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                      
                    <div class="modal-body">
                        <div class="row">
                          <div class="col-md-6 col-sm-6 col-xs-6 text-center">
                            <strong>Nama Pejabat</strong>
                          </div>
                          <div class="col-md-6 col-sm-6 col-xs-6 text-center">
                           <strong>Status</strong>
                          </div>
                        </div>
                      <span v-if="(tampilPejabat)" v-for="(row, index) in tampilPejabat" :key="row.id">
                        <div class="row">
                          <div class="col-md-6 col-sm-6 col-xs-6">
                            <span>{{row.name}}</span>
                          </div>
                          <div class="col-md-6 col-sm-6 col-xs-6 text-center">
                            <span v-if="row.status == 2"><i class="fas fa-times-circle text-red" aria-hidden="true" title="DITOLAK"></i></span>
                            <span v-else-if="row.status == 1"><i class="fas fa-check-circle text-green" aria-hidden="true" title="DITERIMA"></i></span>
                            <span v-else><i class="fas fa-question-circle " aria-hidden="true" title="BELUM DIJAWAB"></i></span>
                          </div>
                        </div>
                        <span v-if="row.status == 2" class="text-red"><strong>ALASAN :</strong> {{row.keterangan}} <br/><br/></span>
                      </span>
                      <span v-else>
                        <div class="row">
                          <div class="col-md-12">
                            GAGAL MENGAMBIL PEJABAT APPROVAL
                          </div>
                        </div>
                      </span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeDetailApprovalModal()">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="uploadBukti" tabindex="-1" role="dialog" aria-labelledby="uploadBukti" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Upload Bukti Pengeluaran</h5>
                    <!--h5 class="modal-title" v-show="editmode">Edit Pengeluaran</h5-->
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="uploadFile()" enctype="multipart/form-data">
                    <div class="modal-body">
                        
                      <div class="form-group">
                        <label>Upload Bukti</label>
                        <div class="custom-file">
                          <input type="file" id="file" name="file" class="custom-file-input" @change="onUploadKTP" :class="{ 'is-invalid': adaeror['file'] }" accept="image/*,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                          <label class="custom-file-label" for="file">{{filename ? filename : 'Choose File'}}</label>
                            <small  v-if="adaeror['file']" class="text-danger">
                                            {{adaeror["file"].join(', ') }}
                                          </small> 
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <!--button v-show="editmode" type="submit" class="btn btn-success">Edit!</button-->
                        <button type="submit" class="btn btn-primary">Upload!</button>
                    </div>
                    
                  </form>
                </div>
            </div>
        </div>
        
    </div>
  </section>
  
  </v-content>
      
  </v-app>
</template>

<script>
    export default {
        data () {
            return {
                uniqueKey: 0,
                datas : [],
                form: new Form({
                    tiket : '',
                    kategori: '',
                    kantor_id: '',
                    pejabat_approval: [],
                    barang : []
                    //tanggal:'',
                }),
                filename: '',
                file: '',
                kategori_list : [],
                kantor_list : [],
                pejabat_list : [],
                adaeror: [],
                menu: false,
                tampilPejabat: '',
                tampilKet: '',
                modaltgl: false,
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                jumlahnya: 0,
                kantorBelumTerpilih : true,
                kategoriBelumTerpilih : true,
            }
        },
        methods: {
          addBarang(){
            this.form.barang.push({
                    barang: '',
                    harga: '',
                    key: this.uniqueKey++
                });
          },
          removeBarang(key){
            this.form.barang.splice(key, 1);
          },
          changeKantor(){
            this.kantorBelumTerpilih = false;
            this.kategoriBelumTerpilih = true;
            this.form.kategori = '';
            this.loadKategori();
          },
          countBudgetnya(){
            this.kategoriBelumTerpilih = false;
          },
          countJumlahnya(){
            Object.entries(this.datas).forEach(([key, val]) => {       
              this.jumlahnya += parseFloat(val.jumlah);
              
            });
          },
          onUploadKTP(e) {
            this.filename = e.target.files[0].name;
            this.file = e.target.files[0];

              if( this.file ){
                  if ( /\.(jpe?g|png|gif|pdf|xls|xlsx|csv|odt)$/i.test( this.filename ) ) {

                  }else{
                    this.filename = "ERROR! Hanya PDF atau Image(JPEG/JPG/PNG) atau Excel (XLS/XLSX/ODT/CSV)";
                    this.file = "";
                  }
              }else{
                this.filename = "";
                this.file = "";
              }
    
          },
          uploadModal(data){
              this.form.reset();
              this.form.jumlah = data.jumlah;
              this.form.kategori = data.kategori_id;
              this.form.keterangan = data.keterangan;
              this.form.kantor_id = data.kantor_id;
              this.form.oleh = data.created_by;
              this.form.id_edit = data.id;

              this.adaeror = [];
              this.filename = "";
              this.file = "";
              //this.data2.keuangan_id = id;
              $('#uploadBukti').modal('show');
          },
          uploadFile(){
              this.$Progress.start();
              const config = {
                headers: {
                    'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                }
              }
              let formData = new FormData();
              formData.append('file', this.file);
              formData.append('datanya', JSON.stringify(this.form));
              axios.post('api/keuangan/approvalAkhir', formData, config)
              .then((data)=>{
                if(data.data.success){
                  $('#uploadBukti').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                  this.$Progress.finish();
                 // this.loadData();
                  this.adaeror = [];
                  this.filename = "";
                  this.file = "";
                  //this.data2.keuangan_id = "";
                } else {
                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });

                  this.$Progress.fail();
                }
              })
              .catch(e=>{
                this.adaeror = e.response.data.errors;
                  this.$Progress.fail();
                  Toast.fire({
                      icon: 'error',
                      title: e.response.data.data
                  });
              })
          },
          getStatusnya(){
            
            Object.entries(this.datas).forEach(([key, val]) => {      this.datas[key]['statusnya'] = val.pejabat_approval_cek.map(elm => elm.status)    });
          },
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
          ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            //this.loadData();       
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          bukaKeteranganModal(id){
            this.tampilKet = id;
            $('#KeteranganModal').modal('show');
          },
          closeKeteranganModal(){
            this.tampilKet = '';
            $('#KeteranganModal').modal('hide');
          },
          bukaDetailApprovalModal(pejabat){
            this.tampilPejabat = pejabat;
            $('#DetailApprovalModal').modal('show');
          },
          closeDetailApprovalModal(){
            this.tampilPejabat = '';
            $('#DetailApprovalModal').modal('hide');
          },
          getResults(page = 1) {

              this.$Progress.start();
              
              axios.get('api/keuangan/permintaanCek?page=' + page).then(({ data }) => (this.datas = data.data));

              this.$Progress.finish();
          },
          loadKantor(){
            axios.get("api/kantor").then(({ data }) => (this.kantor_list = data.data.data));
            
          },
          loadKategori(){
            axios.get("api/keuangan/overview?kantor_id="+this.form.kantor_id.id).then(({ data }) => (this.kategori_list = data.data));
          },
          loadPejabatApproval(){
            axios.get("api/keuangan/pejabat_list").then(({ data }) => (this.pejabat_list = data.data));
          },
          loadData(){
            if(this.$gate.isAllowed("is_keuangan")){
              
              this.jumlahnya = 0;
              
              this.kategoriBelumTerpilih = true;
              this.kantorBelumTerpilih = true;
              
              let tahunpaid = this.tanggal_query.substr(0, 4);
              let bulanpaid = this.tanggal_query.substr(-2, 2);
              //axios.get("api/keuangan/permintaanCek?tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => {
              axios.get("api/keuangan/permintaanCek").then(({ data }) => {
                if(data.data.length){
                  this.datas = data.data;
                  this.getStatusnya();
                  this.countJumlahnya();
                }else{
                  this.datas = false;
                }
              });
              this.tanggal_tampil = this.getBulan(this.tanggal_query);
            }
            // if(this.$gate.isAdmin()){
              //axios.get("api/router").then(({ data }) => (this.datas = data.data));
            // }
          },
          newModal(){
              this.form.reset();
              this.adaeror = [];
              
              this.loadKantor();
              this.loadPejabatApproval();
              $('#addNew').modal('show');
          },
          createData(){
             //console.log( this.form.barang);
             
            this.$Progress.start();
              if(this.form.barang.length > 0){
                if(this.form.pejabat_approval.length > 0){
                
                  const config = {
                    headers: {
                        'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                    }
                  }
                  let formData = new FormData();
                  formData.append('datanya', JSON.stringify(this.form));
                  axios.post('api/keuangan/addPermintaanCek', formData, config)
                  .then((data)=>{
                    if(data.data.success){
                      $('#addNew').modal('hide');

                      Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                      this.$Progress.finish();
                      this.loadData();
                      this.adaeror = [];
                      window.location.reload();
                    } else {
                      Toast.fire({
                          icon: 'error',
                          title: 'Some error occured! Please try again'
                      });

                      this.$Progress.fail();
                    }
                  })
                  .catch(e=>{
                    this.adaeror = e.response.data.errors;
                      this.$Progress.fail();
                      Toast.fire({
                          icon: 'error',
                          title: 'Some error occured! Please try again'
                      });
                  })
                }else{
                  Toast.fire({
                      icon: 'error',
                      title: 'Pejabat Approval belum diisi'
                  });

                  this.$Progress.fail();
                }
              }else{
                Toast.fire({
                    icon: 'error',
                    title: 'Barang Belum Terisi'
                });

                this.$Progress.fail();
              }
          },
          updateData(){
          },
          preventArrow(e) {
            if (e.which === 38 || e.which === 40) {
              e.preventDefault();
            }
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57)
            {
                e.preventDefault();
            }
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          deletePermintaan(id){
            this.$Progress.start();
            Swal.fire({
                title: 'Yakin untuk menghapus?',
                text: "Hanya Permintaan yang telah ditolak atau belum mendapat respon sama sekali yang dapat dihapus.",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, Hapus!'
                }).then((result) => {
                  let formData = new FormData();
                  formData.append('datanya', JSON.stringify(id));
                  axios.post('api/keuangan/deletePermintaanCek', formData)
                  .then((data)=>{
                    if(data.data.success){
                       //this.loadData();
                      Swal.fire(
                          'Terhapus!',
                          'Data Permintaan Berhasil Dihapus.',
                          'success'
                          );
                      this.$Progress.finish();
                    } else {
                      Swal.fire("Hapus Gagal!", data.message, "warning");

                      this.$Progress.fail();
                    }
                  })
                  .catch(e=>{
                    this.adaeror = e.response.data.errors;
                      this.$Progress.fail();
                      Swal.fire("Hapus Gagal!", data.message, "warning");
                  })
                    
                })
          },

        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadData();
            this.$Progress.finish();
            
        }
    }
</script>
<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.tdSembunyi {
    padding: 0 !important;
}

</style>